<div *ngIf="!wohnungSelected" class="choose-wohnung">
  <h1>Wohnungsauswahl</h1>
  <p>Ihrem Zugang sind mehrere Wohnungen zugeordnet.<br>
    Bitte wählen Sie eine Wohnung, um die Verbrauchsdaten dieser einzusehen:</p>
  <div class="wohnungen">
    <div *ngFor="let d of dataList" (click)="selectWohnung(d)" class="wohnung">
      <div class="title1">{{d.title1}}</div>
      <div class="title2">{{d.title2}}</div>
      <div class="hint error" *ngIf="d.status == 406">
        <mat-icon>error</mat-icon>
        Fehler bei der Generierung der Verbrauchsdaten
      </div>
      <div class="hint error" *ngIf="d.status == 412">
        <mat-icon>access_time</mat-icon>
        Steht erst ab dem {{getErrStartDateStr(d)}} zur Verfügung
      </div>
      <div class="hint warning" *ngIf="d.anyInvalid">
        <mat-icon>warning</mat-icon>
        Mindestens ein Wert liegt nicht vor, dieser wurde geschätzt
      </div>
    </div>
  </div>
</div>

<div *ngIf="wohnungSelected">
  <mp-address-header [data]="data"></mp-address-header>

  <mat-form-field *ngIf="hasMultipleWohnungen" class="select-wohnung">
    <mat-label>Gewählte Wohnung</mat-label>
    <mat-select [(ngModel)]="data" (selectionChange)="selectWohnung(data)">
      <mat-option *ngFor="let d of filteredDataList()" [value]="d">
        {{d.titleShort}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mp-overview [werte]="data.werte" [hatHeizung]="data.hatHeizung" [hatWarmwasser]="data.hatWarmwasser"
               [hatKaltwasser]="data.hatKaltwasser"></mp-overview>
</div>


<div class="errors">
  <div *ngIf="data.anyInvalid">
    <mat-icon>warning</mat-icon>
    Mindestens ein Wert liegt nicht vor, dieser wurde geschätzt.
  </div>
</div>
